import {http} from '../../shared/services';

export const LOAD_LESSON_PLAN = 'LOAD_LESSON_PLAN';
export const LOAD_LESSON_PLAN_PENDING = `${LOAD_LESSON_PLAN}_PENDING`;
export const LOAD_LESSON_PLAN_FULFILLED = `${LOAD_LESSON_PLAN}_FULFILLED`;
export const LOAD_LESSON_PLAN_REJECTED = `${LOAD_LESSON_PLAN}_REJECTED`;

export function loadLessonPlan(id, getPendingLessons = false) {
  const url = getPendingLessons ? 'pending_lesson_plans' : 'lesson_plans'
  return {
    type: LOAD_LESSON_PLAN,
    payload: http.get(`${url}/${id}`),
  };
}



// WEBPACK FOOTER //
// ./app/features/lessonDetail/actions/loadLessonPlan.js